import React, { useState, useEffect } from 'react'
import Breadcumb from '../../../components/Breadcumb/Breadcumb'
import { Container } from '@material-ui/core'
import UploadImageModal from '../../../components/ImageEditor/UploadImageModal'
import { SampleGreetings, Alerts } from '../../../helpers'
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  imgEle:{
    width:'100%',
    height:'auto'
  }
}));
const BreadcrumbData = [
  {
    id: 1,
    page_title: "Dashboard",
    page_path: "/",
    icon: "tachometer",
  },
  {
    id: 2,
    page_title: "Sample Greetings",
    page_path: "/",
    icon: "tachometer",
  }
]
const SampleGreeting = () => {
  const classes = useStyles();
  const [isLoading, setLoading] = useState(true)
  const [images, setImages] = useState([]);

  const handleUploadImage = async (acceptedFiles) => {

    let formData = new FormData()
    for (let i = 0; i < acceptedFiles.length; i++) {
      formData.append("images", acceptedFiles[i]);
    }
    let resp = await SampleGreetings.uploadImage(formData);
    if (resp) {
      if (resp.status) {
        Alerts.alertMessage(resp.message, "", "success");
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      }
    }

  }
  const getData = async () => {
    let resp = await SampleGreetings.getSampleGreetings();
    if (resp) {
      if (resp.status) {
        setImages(resp.greetings);
        setLoading(false);
      }
    }
  }
  useEffect(() => {
    getData();
  }, [])
  const deleteRecord = async (id) => {
    let resp = await SampleGreetings.deleteSampleGreetings(id);
    if (resp) {
      Alerts.alertMessage(resp.message, "", "success");
      let remImage = images.filter(el => el.id !== id);
      setImages(remImage);
    }
  }



  return (
    <>
      <Breadcumb items={BreadcrumbData} />
      <div className="page-wrapper pd30">
        <Container >


          <div className='page-inner-header'>
            <h3 className='m-0'>Sample Greetings</h3>
            <UploadImageModal onUpload={handleUploadImage} />
          </div>
          {/* {
                isLoading ? "Data Loading..." : <MUIDataTable
                  title="Categories"
                  data={images.map((item, i) => {
                    return [
                      ++i,
                      <div><img src={item.image_url} alt="" style={{maxWidth:200}}/></div>,
                     
                      <div className='actions'>
                        <button onClick={()=>deleteRecord(item.id)} className=" btn-danger action-btn">
                          <DeleteIcon fontSize="small" />
                        </button>
                      </div>

                    ]
                  })}
                  columns={columns}
                />
              } */}

          <div className={classes.root}>
           {
             isLoading ? "Data Loading..." : <Grid container spacing={2}>
              {
                images.map((item) => {
                  return  <Grid item xs={6} sm={3} key={item.id}>
                  <Paper className={classes.paper}>
                     <img src={item.image_url} alt="" className={classes.imgEle}/>
                     <button onClick={()=>deleteRecord(item.id)} className=" btn-danger action-btn">
                          <DeleteIcon fontSize="small" />
                        </button>
                  </Paper>
                </Grid>
                })
              }
           
           </Grid>
           } 
          </div>
        </Container>
      </div>

    </>
  )
}

export default SampleGreeting;